import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    constructor(private _http: HttpClient) {
    }

    private _formatErrors(error: any) {
        return throwError(error.error);
    }


    public get(
        path: string,
        params: HttpParams = new HttpParams(),
    ): Observable<any> {
        return this._http
            .get(`${environment.api3Url}${path}`, {params})
            .pipe(catchError(this._formatErrors));
    }

    public put(path: string, body: object = {}): Observable<any> {
        return this._http
            .put(`${environment.api3Url}${path}`, body)
            .pipe(catchError(this._formatErrors));
    }

    public patch(path: string, body: object = {}): Observable<any> {
        return this._http
            .patch(`${environment.api3Url}${path}`, body)
            .pipe(catchError(this._formatErrors));
    }

    public post(path: string, body: object = {}): Observable<any> {
        return this._http
            .post(`${environment.api3Url}${path}`, body)
            .pipe(catchError(this._formatErrors));
    }

    public delete(path): Observable<any> {
        return this._http
            .delete(`${environment.api3Url}${path}`)
            .pipe(catchError(this._formatErrors));
    }

}
